import { faFileImport } from '@fortawesome/free-solid-svg-icons/faFileImport'
import { faFileExport } from '@fortawesome/free-solid-svg-icons/faFileExport'

export const getDataToCsvControls = (
    handleImportFromCsv: () => void,
    handleExportToCsv: () => void
) => {
    return [
        {
            name: 'buttons.importFromCsv',
            action: handleImportFromCsv,
            icon: faFileImport,
        },
        {
            name: 'buttons.exportToCsv',
            action: handleExportToCsv,
            icon: faFileExport,
        },
    ]
}
